import React, {FunctionComponent} from 'react'
import { IProps } from './IProps'
import {Number} from '../Number'

// tslint:disable-next-line:variable-name
export const Currency: FunctionComponent<IProps> = ({
    children,
    ...props
}) => {
    return <Number style={'currency'} {...props}>{children}</Number>
}
